export const clampQuantity = (value, minimum = 1, maximum = 999) => {
    const safeMinimum = Math.max(1, Number.parseInt(minimum, 10) || 1);
    const safeMaximum = Math.max(safeMinimum, Number.parseInt(maximum, 10) || 999);
    const quantity = Number.parseInt(value, 10);

    return Math.min(safeMaximum, Math.max(safeMinimum, Number.isFinite(quantity) ? quantity : safeMinimum));
};

export const getNextQuantity = (current, delta, minimum = 1, maximum = 999) =>
    clampQuantity(
        (Number.parseInt(current, 10) || minimum) + (Number.parseInt(delta, 10) || 0),
        minimum,
        maximum,
    );

export const createCartItemUrl = (endpoint, key, action = '', baseUrl = 'http://localhost/') => {
    const base = new URL(String(endpoint || ''), baseUrl);
    const safeKey = encodeURIComponent(String(key || '').replace(/[^A-Za-z0-9_-]/g, ''));
    const suffix = action ? `/${encodeURIComponent(String(action))}` : '';
    base.pathname = `${base.pathname.replace(/\/$/, '')}/items/${safeKey}${suffix}`;

    return base.toString();
};

export const normalizeCartPayload = (payload) => {
    const source = payload && typeof payload === 'object' ? payload : {};
    const count = Math.max(0, Number.parseInt(source.count, 10) || 0);
    const items = Array.isArray(source.items) ? source.items.filter(Boolean) : [];
    const progress = source.shipping_progress && typeof source.shipping_progress === 'object'
        ? source.shipping_progress
        : {};
    const summary = source.summary && typeof source.summary === 'object' ? source.summary : {};
    const savings = summary.savings && typeof summary.savings === 'object'
        ? summary.savings
        : {};

    return {
        ...source,
        status: String(source.status || 'ready'),
        is_empty: Boolean(source.is_empty ?? count === 0),
        count,
        count_label: String(source.count_label || `${count} produktów`),
        items,
        shipping_progress: {
            ...progress,
            enabled: Boolean(progress.enabled),
            complete: Boolean(progress.complete),
            percent: Math.min(100, Math.max(0, Number(progress.percent) || 0)),
            message: String(progress.message || ''),
            caption: String(progress.caption || ''),
        },
        summary: {
            ...summary,
            rows: Array.isArray(summary.rows) ? summary.rows.filter(Boolean) : [],
            total: String(summary.total || ''),
            savings: {
                ...savings,
                amount: Math.max(0, Number(savings.amount) || 0),
                formatted: String(savings.formatted || ''),
                visible: Boolean(savings.visible),
            },
        },
        nonce: String(source.nonce || ''),
        rest_nonce: String(source.rest_nonce || ''),
    };
};

export const shouldOpenCartFromClick = (event) =>
    !event.defaultPrevented
    && (event.button === undefined || event.button === 0)
    && !event.metaKey
    && !event.ctrlKey
    && !event.shiftKey
    && !event.altKey;

export const getCartDrawerCleanUrl = (value, baseUrl = 'http://localhost/') => {
    try {
        const url = new URL(String(value || ''), baseUrl);

        if (url.searchParams.get('seluvia-cart') !== 'open') {
            return null;
        }

        url.searchParams.delete('seluvia-cart');

        return `${url.pathname}${url.search}${url.hash}`;
    } catch {
        return null;
    }
};

export const getDrawerDragOffset = (startX, currentX, width) => {
    const maximum = Math.max(1, Number(width) || 1);
    const delta = Math.max(0, Number(currentX) - Number(startX));

    return Math.min(maximum, delta);
};

export const shouldCloseFromSwipe = ({ distance, duration, width }) => {
    const safeDistance = Math.max(0, Number(distance) || 0);
    const safeDuration = Math.max(1, Number(duration) || 1);
    const safeWidth = Math.max(1, Number(width) || 1);
    const velocity = safeDistance / safeDuration;

    return safeDistance >= Math.min(140, safeWidth * 0.3) || velocity >= 0.55;
};
